module.exports = __webpack_public_path__ + "assets/ca298693b85e6d44fafddeb94379ce8b.mp3";